import { RootStore } from '~/stores/root.store';
import { trackError } from '~/services/logger/error.utils';
import { TPollingType } from '~/components/Membership/types/membership.types';
import { LoggerService } from '~/services/logger/logger.service';

export class PollingSubscription {
    rootStore: RootStore;
    logger: LoggerService;

    constructor(rootStore: RootStore, logger: LoggerService) {
        this.rootStore = rootStore;
        this.logger = logger;
    }
    async initiatePolling(pollingType: TPollingType, attempts = 20) {
        const { userStore } = this.rootStore;
        const wasSuccessfulFetch = await this.getCondition(pollingType);
        if (wasSuccessfulFetch && attempts) {
            await new Promise(resolve => {
                setTimeout(async () => {
                    resolve(
                        // eslint-disable-next-line no-param-reassign
                        await this.initiatePolling(pollingType, --attempts)
                    );
                }, 500);
            });
        }
        if (!attempts) {
            trackError({
                error: new Error('Polling timeout on: '),
                context: {
                    _id: userStore.currUser._id,
                    pricing_and_packaging: true
                }
            });
        }
    }
    async getCondition(pollingType: TPollingType) {
        const { membershipUiStore, membershipCtrl, userStore } = this.rootStore;
        switch (pollingType) {
            case 'downgrade': {
                const subscriptionChanges =
                    await membershipCtrl.getNextPayment();
                return (
                    subscriptionChanges?.[0]?.attributes?.line_items[0]
                        ?.attributes?.plan_code !==
                    membershipUiStore.selectedPlanCode
                );
            }
            case 'cancel_downgrade': {
                const subscriptionChanges =
                    await membershipCtrl.getNextPayment();
                const oldPlanCode =
                    userStore.currUser.account?.subscription?.pricing_plan
                        ?.plan_type;
                const newPlanCode =
                    subscriptionChanges[0]?.attributes?.line_items[0]
                        ?.attributes?.plan_code;
                return newPlanCode !== oldPlanCode;
            }
            case 'upgrade': {
                const { pricing_plan } =
                    await membershipCtrl.fetchCurrUserAccount(this.logger);
                return (
                    pricing_plan?.plan_type !==
                    membershipUiStore.selectedPlanCode
                );
            }
            case 'reactivate': {
                await membershipCtrl.fetchCurrUserAccount(this.logger);
                return userStore.currUser.isSubscriptionCanceled;
            }
            default: {
                trackError({
                    error: new Error('missing definition of polling for type'),
                    context: {
                        pricing_and_packaging: true
                    }
                });
                return false;
            }
        }
    }
}
